import clsx from "clsx";
import PropTypes from "prop-types";
import "./radio-button.scss";

export const Radio = ({ className = "", onChange, ...props }) => {
  // Matching the semantic-ui-react API for onChange so we can swap
  // out their component with ours easily
  const handleChange = (e) => {
    onChange(e, { ...props, checked: e.target.checked });
  };

  return (
    <input
      {...props}
      className={clsx("ha-radio-button", className)}
      onChange={handleChange}
      type="radio"
    />
  );
};

Radio.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
